const availableAddons = [{
  value: 'dedicatedAnalyst',
  label: 'Dedicated analyst',
}, {
  value: 'unlimitedHeatmaps',
  label: 'Unlimited heatmaps and recordings',
}];

module.exports = {
  availableAddons,
};
